import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import Text from '../../ui/Text'
import useText from '../../common/hooks/useText'

const SLink = styled.a<{ dark?: boolean }>`
    font-size: 16px;
    font-weight: 400;

    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme, dark }) => (dark ? theme.font.lightestColor : theme.font.midDarkColor)};
    }
`

const SFooter = styled.div`
    padding: 42px;
    display: flex;
    gap: 37px;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 576px) {
        padding: 15px;
        gap: 19px 35px;
    }
`

const SCopyright = styled.span`
    font-weight: 300;
    font-size: 16px;
`

export type LandingPageFooterProps = {
    dark?: boolean
    className?: ClassName
    style?: React.CSSProperties
}

export function LandingPageFooter({ dark, className, style }: LandingPageFooterProps): React.ReactElement {
    const text = useText()
    return (
        <SFooter className={cn(className)} style={style}>
            <SCopyright data-testid="copyright">
                <Text code="lblCopyright" />
            </SCopyright>
            <SLink
                href={`https://www.chargeamps.com/${text('linkLegal')}`}
                target="_blank"
                rel="noopener noreferrer"
                dark={dark}
                data-testid="termsOfService"
            >
                <Text code="lblTermsOfService" />
            </SLink>
            <SLink
                href={`https://www.chargeamps.com/${text('linkSupport')}`}
                target="_blank"
                rel="noopener noreferrer"
                dark={dark}
                data-testid="linkSupport"
            >
                <Text code="lbllinkSupport" />
            </SLink>
        </SFooter>
    )
}
